import * as Sentry from '@sentry/react'
import { IEnvironment } from 'mhbo-js'

const DEFAULT_DSN =
  'https://edaa6fddeb78036dcf5265313f7d18fd@o4511700478394368.ingest.us.sentry.io/4511775166955521'

const REPORTED_ENVIRONMENTS: { [key: string]: string } = {
  [IEnvironment.Production]: 'production',
  [IEnvironment.Staging]: 'staging',
}

const initSentry = () => {
  const environment = REPORTED_ENVIRONMENTS[process.env.REACT_APP_API_ENV || '']

  if (!environment) {
    return
  }

  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN || DEFAULT_DSN,
    environment,
    release: process.env.REACT_APP_VERSION || undefined,
    initialScope: {
      tags: { source: 'maps-frontend' },
    },
  })
}

export default initSentry
